import TmLogicError from '@/core/error/tmLogicError'

export const parseConnectionId = (id: string | string[]) => {
  if (typeof id !== 'string') {
    throw new TmLogicError('"id" should be type string')
  }

  const connectionId = parseInt(id, 10)

  if (Number.isNaN(connectionId)) {
    throw new TmLogicError('"id" should be a valid number')
  }

  return connectionId
}
